// @flow
import buildWalkingStep from './walkSearchStep'
import buildPrebookStep from './prebookSearchStep'
import buildOndemandStep from './ondemandSearchStep'
import { TRIP_TYPE } from '../../../constants/tripType'
import { STEP_TYPE } from '../../../constants/stepType'

// Types
import type { Step } from '../../../models/step'
import type {
  BaseSearchTrip,
  SearchResponse,
  PrebookSearchStep,
  PrebookWalkStep,
  OndemandSearchStep,
} from '../../../api_types'

/**
 * Build step for any trip type. By given type call appropreate trip builder
 * @param  {Object} step     Step object of the trip
 * @param  {Object} trip     The trip object
 * @param  {Object} response The whole search response object
 * @param  {bool}   isReturnTrip Whether the step is for the return trip
 * @return {Object}
 * @private
 */
export function searchStepBuilder(
  step: any,
  trip: BaseSearchTrip,
  response: SearchResponse,
  isReturnTrip: boolean
): Step {
  if (step.step_type === STEP_TYPE.WALK) {
    return buildWalkingStep((step: PrebookWalkStep))
  }
  if (trip.type === TRIP_TYPE.ON_DEMAND) {
    return buildOndemandStep((step: OndemandSearchStep), response)
  }
  if (
    !trip.type ||
    trip.type === TRIP_TYPE.PREBOOK ||
    trip.type === TRIP_TYPE.PUBLIC_TRANSPORTATION
  ) {
    return buildPrebookStep((step: PrebookSearchStep), response, isReturnTrip)
  }

  throw new Error('Some unkonwn step type received')
}

export default searchStepBuilder
